import { basePathIcons, SvgIcon } from '@y42/core/icon';

const iconsBasePath = `${basePathIcons}/y42-logos`;

export const y42ShortLogoIcon: SvgIcon = `${iconsBasePath}/y42-short-logo.svg`;
export const y42DarkLogo: SvgIcon = `${iconsBasePath}/y42-logo-dark.svg`;
